import { usePage } from '@inertiajs/react'

/**
 * Se a página está sendo servida pelo host do Explore (explore.bewave.surf).
 *
 * A resposta vem do servidor, pela shared prop `on_explore`
 * (ApplicationController), e não de `window.location`: quem sabe quais hosts
 * são o Explore é o `ExploreHost`, e a lista muda por ambiente e por ENV —
 * duplicá-la no front é como ela diverge.
 *
 * Sem a prop, `false`. É o caso das telas que não passam pelo
 * ApplicationController e o de um teste que não a define: nos dois, o header se
 * comporta como se estivesse na landing, que é o que fazia antes disto existir.
 */
export function useOnExplore(): boolean {
  return usePage<{ on_explore?: boolean }>().props.on_explore === true
}
